import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-offline-banner',
  imports: [TranslatePipe],
  templateUrl: './offline-banner.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './offline-banner.scss',
})
export class OfflineBanner {}
